import React from 'react'
import ReCAPTCHA from "react-google-recaptcha";
import { useState } from "react";
import config from '../config/config';
import axios from '../config/axios';


function Footer({ clientIpAddress }) {
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [recaptchaResponse, setRecaptchaResponse] = useState("");
    const [emailError, setEmailError] = useState("");
    const [inputError, setInputError] = useState(false);
    const [inputError1, setInputError1] = useState('');
    const [newsletterres, setnewsletterres] = useState('');
    const handleSubmit = (event) => {
        event.preventDefault();

        if (name === '' || email === '') {
            setInputError(true);
            return;
        }

        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        // Check if the email is valid
        if (!emailRegex.test(email)) {
            // Display an error message or handle the case when the email format is invalid
            // For example:
            setEmailError('Please enter a valid email address');
            return;
        }

        // Execute reCAPTCHA to get the token
        window.grecaptcha.execute("6LfhLKQkAAAAADv4QLes3emiEmZx7ReBBiT6YbBN", { action: 'submit' })
            .then((token) => {
                // Verify if the reCAPTCHA response is available
                if (token === "") {
                    // Display an error message or handle the case when the reCAPTCHA is not completed
                    return;
                }

                const general = {
                    name: name,
                    email: email,
                    ip_address: clientIpAddress,
                    token: token,
                };

                // Make the API request using axios
                return axios.post('api/partneronboarding/newsletter', { general: JSON.stringify(general) });
            })
            .then((response) => {
                if (response.status === 200) {
                    setEmail('');
                    setName('');
                    // setnewsletterres("Thanks for contacting us.");
                    window.location.href= `${config.baseurl}/thankyou`;
                } else {
                    setnewsletterres(response.message);
                }
                setTimeout(() => {
                    setnewsletterres('');
                }, 3000);
            })
            .catch((error) => {
                setnewsletterres("Something went wrong.");
                setTimeout(() => {
                    setnewsletterres('');
                }, 3000);
            });
    };




    const handleNameChange = (event) => {
        setInputError(false);
        setName(event.target.value);
    };



    const handleEmailChange = (event) => {
        setInputError(false);
        setEmailError('');
        const email = event.target.value;
        setEmail(email);

        // Email validation regex pattern

    };



    return (
        <div>
            <footer class="bg-white new-footer">
                <div class="container">
                    <div class="row mb-md-3 mb-5">
                        <div class="col-lg-12 col-md-2">
                            <img src={`${config.baseurl}/assets/images/new_website_design/logo.svg`} style={{ width: 180 }} class="img-fluid mb-2" />
                            <ul class="ft-social-links d-flex d-md-none">
                                <li><a href="https://twitter.com/ZyraTalk">
                                    <img src={`${config.baseurl}/assets/images/new_website_design/twitter.svg`} /></a></li>
                                {/* <li><a href="https://www.instagram.com/zyratalk/">
                                    <img src={`${config.baseurl}/assets/images/new_website_design/insta.svg`} /></a></li> */}
                                <li><a href="https://www.facebook.com/ZyraTalk-108027657545443/">
                                    <img src={`${config.baseurl}/assets/images/new_website_design/fb.svg`} /></a></li>
                                <li><a href="https://www.linkedin.com/company/zyratalk/">
                                    <img src={`${config.baseurl}/assets/images/new_website_design/linkedin.svg`} /></a></li>
                            </ul>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-3 col-sm-6 col-12 order-2 order-md-1">
                            <ul class="ft-links ft-contact">
                                <li><a href=""><img src={`${config.baseurl}/assets/images/new_website_design/home_icon.jpg`} alt='' />
                                    <span >2398 E Camelback Rd, STE 1020 <br /> Phoenix, AZ 85016</span></a></li>
                                <li><a href="tel:(888)435-9109"><i class="fa fa-phone-alt"></i> <span>(888)435-9109</span></a></li>
                                <li><a href="mailto:support@zyratalk.co"><i class="fa fa-envelope"></i><span>support@zyratalk.co</span></a></li>
                            </ul>
                            <ul class="ft-social-links d-none d-md-flex">
                                <li><a href="https://twitter.com/ZyraTalk"><img src={`${config.baseurl}/assets/images/new_website_design/twitter.svg`} /></a></li>
                                {/* <li><a href="https://www.instagram.com/zyratalk/"><img src={`${config.baseurl}/assets/images/new_website_design/insta.svg`} /></a></li> */}
                                <li><a href="https://www.facebook.com/ZyraTalk-108027657545443/"><img src={`${config.baseurl}/assets/images/new_website_design/fb.svg`} /></a></li>
                                <li><a href="https://www.linkedin.com/company/zyratalk/"><img src={`${config.baseurl}/assets/images/new_website_design/linkedin.svg`} /></a></li>
                            </ul>
                        </div>
                        <div class="col-md-3 col-sm-6 col-12 order-1 order-md-2">
                            <h4 class="ft-heading">Use Cases</h4>
                            <ul class="ft-links">
                                <li><a href={`${config.baseurl}/automate-customer-support`}>Automate Customer Support</a></li>

                                {/* <!--li><a  href="#">Financial Services</a></li> */}
                                <li><a href={`${config.baseurl}/increase-online-leads`}>Increase Online Leads</a></li>
                                <li><a href={`${config.baseurl}/improved-hiring-process`}>Improved Hiring Process</a></li>
                            </ul>
                        </div>
                        <div class="col-md-3 col-sm-6 col-12 order-3 order-md-3">
                            <h4 class="ft-heading">Resources</h4>
                            <ul class="ft-links">
                                <li><a href={`${config.baseurl}/request-demo`}>Get a Demo</a></li>
                                <li><a href={`${config.baseurl}/terms`}>Terms of Use</a></li>
                                <li><a href={`${config.baseurl}/privacy-policy`}>Privacy Policy</a></li>
                                <li><a href={`${config.baseurl}/partnerterms`}>Partner Terms</a></li>
                                <li><a href={`${config.baseurl}/blogs`}>Blogs</a></li>
                            </ul>
                        </div>
                        <div class="col-md-3 col-sm-6 col-12 order-4">
                            <h4 class="ft-heading">Get Started!</h4>
                            {newsletterres && <p class="alert alert-success mb-4 formRes2">{newsletterres}</p>}
                            <form class="newsletter-form" onSubmit={handleSubmit} id="newsletter-form1" data-hs-cf-bound="true">
                                <input type="hidden" id="__token" name="csrf_token" value="b97e382b6736b0921c9e8278e48aca12" />
                                <div class="mb-2">
                                    <label class="form-label mb-0">Name</label>
                                    <input type="text" name="name" id="name" class="form-control" placeholder="" value={name} onChange={handleNameChange} />
                                    {(name === '' && inputError) && <div style={{ color: 'red', textAlign: 'left' }}>This is a required field.</div>}

                                </div>
                                <div class="mb-4">
                                    <label class="form-label mb-0">Email</label>
                                    <input type="text" name="email" id="emails" class="form-control placeholder-opacity-75 md:placeholder-opacity-50" style={{ "::placeholder": { opacity: 0.5 } }} value={email} onChange={handleEmailChange} placeholder="hello@zyratalk.com" />
                                    {(email === '' && inputError) && <div style={{ color: 'red', textAlign: 'left' }}>This is a required field.</div>}
                                    {emailError && <div style={{ color: 'red', textAlign: 'left' }}>{emailError}</div>}


                                </div>

                                <button type="submit" class="nav-link main_btns fw-bold mr-lg-0 me-lg-4 px-4 sign-up-btn text-white" style={{ backgroundColor: '#0603B8', borderColor: '#0603B8' }}>Get Started</button>
                                <div class="spinner-border text-center" id="loader" role="status" style={{ display: 'none' }}>
                                    <span class="sr-only">Loading...</span>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </footer>
        </div>
    )
}

export default Footer;